export { YearInsuranceRatesRegister } from './YearInsuranceRatesRegister';
